import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "linkItemDv" }
const _hoisted_2 = {
  key: 1,
  class: "firstdv"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "textDv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showRemove)
      ? (_openBlock(), _createBlock(_component_IconComponent, {
          key: 0,
          class: "iconnotinfoDv",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onRemove()), ["stop"])),
          onTouchstart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRemove())),
          id: `minusWining${_ctx.index}`,
          icon: "minus.svg"
        }, null, 8, ["id"]))
      : _createCommentVNode("", true),
    (_ctx.favIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("figure", null, [
            _createElementVNode("img", {
              src: `https://www.google.com/s2/favicons?domain=${_ctx.trade.link}`,
              alt: "Icon here."
            }, null, 8, _hoisted_3)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isOverflowing)
        ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 0,
            class: "box-item",
            effect: "dark",
            placement: "top-start",
            content: _ctx.trade.title
          }, {
            default: _withCtx(() => [
              _createElementVNode("h1", { ref: "title" }, _toDisplayString(_ctx.trade.title), 513)
            ]),
            _: 1
          }, 8, ["content"]))
        : (_openBlock(), _createElementBlock("h1", {
            key: 1,
            ref: "title"
          }, _toDisplayString(_ctx.trade.title), 513)),
      _createElementVNode("div", {
        class: "iconinfoDv",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openURL()))
      }, [
        _createElementVNode("p", { ref: "url" }, _toDisplayString(_ctx.sharingUrl), 513),
        _createVNode(_component_IconComponent, {
          class: "iconLinkDv",
          icon: "icon-link.svg"
        })
      ])
    ])
  ]))
}